const dayMillisecs = 24 * 60 * 60 * 1000;

export function getFirstDayOfTheWeek(fromDate) {
    /*  d = new Date(d);
      let day = d.getDay(),
          diff = d.getDate() - day + (day == 0 ? -6:1); // adjust when day is sunday
      return new Date(d.setDate(diff));*/

    // Get Date object truncated to date.
    var d = new Date(new Date(fromDate || Date()).toISOString().slice(0, 10));

    // If today is Sunday (day 0) subtract an extra 7 days.
    var dayDiff = d.getDay() === 0 ? 7 : 0;

    // Get date diff in millisecs to avoid setDate() bugs with month boundaries.
    // This assumes that the first day of week is sunday. So add one day to make it jmonday
    var mondayMillisecs = d.getTime() - (d.getDay() + dayDiff) * dayMillisecs + dayMillisecs;

    // Return date as YYYY-MM-DD string.
    //return new Date(mondayMillisecs).toISOString().slice(0, 10);
    return new Date(mondayMillisecs);
}

export function getLastDayOfTheWeek(d) {
    const monday = getFirstDayOfTheWeek(d);
    var lastdayMillisecs = monday.getTime() + (monday.getDay() + 5) * dayMillisecs;
    return new Date(lastdayMillisecs);
}

export function plusDate(d, val) {
    var lastdayMillisecs = d.getTime() + val * dayMillisecs;
    return new Date(lastdayMillisecs);
}

/* Find array from array */
export function searchDateFromArray(nameKey, myArray) {
    let workouts = [];
    for (let i = 0; i < myArray.length; i++) {
        if (myArray[i].date === nameKey) {
            workouts.push(myArray[i]);
        }
    }
    return workouts;
}

export function searchFromArray(value, myArray) {
    let result = [];
    for (let i = 0; i < myArray.length; i++) {
        if (myArray[i] === value) {
            result.push(myArray[i]);
        }
    }
    return result;
}

export function searchElementFromElementsOfArray(key, value, myArray) {
    let returnElement = null;
    if (myArray !== null) {
        for (let i = 0; i < myArray.length; i++) {
            if (myArray[i][key] === value) {
                returnElement = myArray[i];
                break;
            }
        }
        return returnElement;
    } else {
        return null;

    }
}

// Formatoidaan päivä muotoon: <todo>
export function formatDate(d, type) {
    let m = d.getMonth() + 1; // 0-11
    if (m.toString().length == 1) {
        m = "0" + m;
    }
    const y = d.getFullYear();
    let day = d.getDate();
    // Stupid short cut to make something happen fast
    if (type == "d") {
        return day;
    }
    if (day.toString().length == 1) {
        day = "0" + day;
    }
    return day + "." + m + "." + y;
}

/**
 * Ottaa stringin ja parsii vaikka "2021-01-16T13:56:30Z" muotoon 16.1.2021
 * @param str
 * @returns {string}
 */
export function parseTimestampStr(str) {
    return new Date(Date.parse(str)).toLocaleDateString("fi-FI");
}

/* Give date string as yyyy-mm-dd -> saat suomalaisen formaatin */
export function formatISODateString2FinDate(dateString) {
    const d = new Date(dateString);
    return d.toLocaleDateString("fi-FI");
}

/**
 * Anna js date - new Date()
 * Saat ulos stringin yyyy-MM-dd
 */
export function JsDate2ISODateStr(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}

/**
 * Parsi yyyy-mm-dd muotoinen päivämäärä js dateksi
 */
export function parseISODateStr2JsDate(dateString) {
    const d = new Date(dateString);
    return d;

}

/**
 * Anna parametriksi date object, esim new Date()
 * @param d
 * @returns {Date[]}
 */
export function firstAndLastDateOfJSDate(d) {
    const kuukaudenNumero = d.getMonth();
    const vuodenNumero = d.getFullYear();

    // Luo ensimmäinen päivä
    const ensimmainenPaiva = new Date(vuodenNumero, kuukaudenNumero, 1);

    // Luo viimeinen päivä
    const viimeinenPaiva = new Date(vuodenNumero, kuukaudenNumero + 1, 0);

    // Palauta ensimmäinen ja toinen päivä
    return [ensimmainenPaiva, viimeinenPaiva];
}

/**
 *  Anna js date - new Date()
 * Saat ulos stringin 3.9.2021 13:13
 * Jos tietokantaan on tallennettu sql.Timestamp. Niin tämä antaa oikean ajan. Näin toimitaan mm. kassassa
 * ja asiakkaiden kanssa.
 * Truportalista taas tulee aika varmaankin UTC aikana. Tämä pitää huomioida.
 * Eli silloin tämä funktio taitaa antaa pari tuntia liian myöhäisen ajan. Voisi tehdä siihen käyttöön jonkun tunnistuksen tai
 * oman funktion.
 */
export function JsDate2DateTimeStr(d) {
    if (d != null && d !== undefined) {
        const day = d.getUTCDate();
        const month = d.getUTCMonth() + 1;
        let min = 0;
        if (d.getMinutes().toString().length == 1) {
            min = "0" + d.getMinutes();
        } else {
            min = d.getMinutes();
        }
        return day + "." + month + "." + d.getFullYear() + " " + d.getUTCHours() + ":" + min;
    } else {
        return '';
    }
}

/**
 * Parsii vaikka "2021-01-16T13:56:30Z" muotoon 13:56
 *
 * @param str
 * @returns {string}
 */
export function parseTimestampStrToTime(str) {
    let time = new Date(Date.parse(str));
    let hours = time.getHours().toString();
    if (hours.length == 1) hours = "0" + hours;
    let minutes = time.getMinutes().toString();
    if (minutes.length == 1) minutes = "0" + minutes;

    return hours + ":" + minutes;
}

/**
 * Parsii vaikka "2021-01-16T13:56:30Z" muotoon 13:56
 *
 * @param str
 * @returns {string}
 */
export function parseTimestampStrToDateTime(str) {
    // Palautetaan tyhjä, jos on null
    if(str === null || str === undefined) {
        return "";
    }

    let time = new Date(Date.parse(str));
    let month = time.getMonth();
    if (month.length == 1) {
        month = "0" + month + 1;
    } else {
        month = month + 1;
    }
    let hours = time.getHours().toString();
    if (hours.length == 1) hours = "0" + hours;
    let minutes = time.getMinutes().toString();
    if (minutes.length == 1) minutes = "0" + minutes;

    return time.getDate() + "." + month + "." + time.getFullYear() + " " + hours + ":" + minutes;
}

/**
 * Päätellään, että onko annettu date tänään
 * @param date
 * @returns {boolean}
 */
export function isToday(date) {
    const today = new Date();
    return date.getDate() === today.getDate() &&
        date.getMonth() === today.getMonth() &&
        date.getFullYear() === today.getFullYear();
}

// Funktio, jolla voidaan hakea evästeen nimellä evästeen kaikki tiedot
export function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

export function validateEmail(email) {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
}


/**
 * Enkoodataan string eli käytännössä featuret
 * @param featureName
 * @returns {string}
 */
export function encodeFeatureName(featureName) {
    //console.log("encodeFeatureName: ", featureName, btoa(featureName), atob(btoa(featureName)));
    return btoa(featureName);
}

/**
 * Dekoodataan string eli käytännössä featuret - Saadaan siis niistä selkokielisiä, niin helpompi koodata
 * @param encodedFeatureName
 * @returns {string}
 */
export function decodeFeatureName(encodedFeatureName) {
    return atob(encodedFeatureName);
}

export let ccOptions = {
    current_lang: 'fi',
    autoclear_cookies: true,                   // default: false
    page_scripts: true,                        // default: false

    // mode: 'opt-in'                          // default: 'opt-in'; value: 'opt-in' or 'opt-out'
    // delay: 0,                               // default: 0
    // auto_language: '',                      // default: null; could also be 'browser' or 'document'
    // autorun: true,                          // default: true
    // force_consent: false,                   // default: false
    // hide_from_bots: true,                   // default: true
    // remove_cookie_tables: false             // default: false
    // cookie_name: 'cc_cookie',               // default: 'cc_cookie'
    // cookie_expiration: 182,                 // default: 182 (days)
    // cookie_necessary_only_expiration: 182   // default: disabled
    // cookie_domain: location.hostname,       // default: current domain
    // cookie_path: '/',                       // default: root
    // cookie_same_site: 'Lax',                // default: 'Lax'
    // use_rfc_cookie: false,                  // default: false
    // revision: 0,                            // default: 0

    onFirstAction: function (user_preferences, cookie) {
        // callback triggered only once on the first accept/reject action
    },

    onAccept: function (cookie) {
        // callback triggered on the first accept/reject action, and after each page load
    },

    onChange: function (cookie, changed_categories) {
        // callback triggered when user changes preferences after consent has already been given
        // Päivitetään sivu, jotta saadaan wodconnect ja facebookfeed näkyviin
        location.reload();
    },

    languages: {
        'en': {
            consent_modal: {
                title: 'We use cookies!',
                description: 'Hi, this website uses essential cookies to ensure its proper operation and tracking cookies to understand how you interact with it. The latter will be set only after consent. <button type="button" data-cc="c-settings" class="cc-link">Let me choose</button>',
                primary_btn: {
                    text: 'Accept all',
                    role: 'accept_all'              // 'accept_selected' or 'accept_all'
                },
                secondary_btn: {
                    text: 'Reject all',
                    role: 'accept_necessary'        // 'settings' or 'accept_necessary'
                }
            },
            settings_modal: {
                title: 'Cookie preferences',
                save_settings_btn: 'Save settings',
                accept_all_btn: 'Accept all',
                reject_all_btn: 'Reject all',
                close_btn_label: 'Close',
                cookie_table_headers: [
                    {col1: 'Name'},
                    {col2: 'Domain'},
                    {col3: 'Expiration'},
                    {col4: 'Description'}
                ],
                blocks: [
                    {
                        title: 'Cookie usage 📢',
                        description: 'I use cookies to ensure the basic functionalities of the website and to enhance your online experience. You can choose for each category to opt-in/out whenever you want. For more details relative to cookies and other sensitive data, please read the full <a href="#" class="cc-link">privacy policy</a>.'
                    }, {
                        title: 'Strictly necessary cookies',
                        description: 'These cookies are essential for the proper functioning of my website. Without these cookies, the website would not work properly',
                        toggle: {
                            value: 'necessary',
                            enabled: true,
                            readonly: true          // cookie categories with readonly=true are all treated as "necessary cookies"
                        }
                    }, {
                        title: 'Performance and Analytics cookies',
                        description: 'These cookies allow the website to remember the choices you have made in the past',
                        toggle: {
                            value: 'analytics',     // your cookie category
                            enabled: false,
                            readonly: false
                        },
                        cookie_table: [             // list of all expected cookies
                            {
                                col1: '^_ga',       // match all cookies starting with "_ga"
                                col2: 'google.com',
                                col3: '2 vuotta',
                                col4: '',
                                is_regex: true
                            },
                            {
                                col1: '_gid',
                                col2: 'google.com',
                                col3: '1 päivä',
                                col4: '',
                            }
                        ]
                    }, {
                        title: 'Advertisement and Targeting cookies',
                        description: 'These cookies collect information about how you use the website, which pages you visited and which links you clicked on. All of the data is anonymized and cannot be used to identify you',
                        toggle: {
                            value: 'targeting',
                            enabled: false,
                            readonly: false
                        }
                    }, {
                        title: 'More information',
                        description: 'For any queries in relation to our policy on cookies and your choices, please <a class="cc-link" href="#yourcontactpage">contact us</a>.',
                    }
                ]
            }
        },
        'fi': {
            consent_modal: {
                title: 'Sivustolla käytetään evästeitä',
                description:
                    'Näiden evästeiden avulla näemme, miten eri sivumme toimivat ja miten käyttäjät liikkuvat sivustollamme.' +
                    'Kaikki tiedot näistä evästeitä kootaan yhteen ja anonymisoidaan. os et salli näitä evästeitä, emme tiedä, milloin olet käynyt sivuillamme emmekä voi seurata sivun toimivuutta.' +
                    ' <button type="button" data-cc="c-settings" class="cc-link"> Asetukset</button>',

                primary_btn: {
                    text: 'Hyväksy kaikki',
                    role: 'accept_all'              // 'accept_selected' or 'accept_all'
                },
                secondary_btn: {
                    text: 'Estä kaikki',
                    role: 'accept_necessary'        // 'settings' or 'accept_necessary'
                }
            },
            settings_modal: {
                title: 'Evästeasetukset',
                save_settings_btn: 'Tallenna',
                accept_all_btn: 'Hyväksy kaikki',
                reject_all_btn: 'Kiellä',
                close_btn_label: 'Sulje',
                cookie_table_headers: [
                    {col1: 'Nimi'},
                    {col2: 'Domain'},
                    {col3: 'Vanhenee'},
                    {col4: 'Kuvaus'}
                ],
                blocks: [
                    {
                        title: 'Evästeiden käyttö 📢',
                        description: 'Käytämme evästeitä sivuston toiminnan parantamiseksi ja varmistamiseksi, sekä suorituskyvyn ja käyttämisen seuraamiseksi.'
                    }, {
                        title: 'Välttämättmömät evästeet',
                        description: 'Nämä evästeet ovat välttämättömiä sivuston toiminnan kannalta. ' +
                            'Ilman näitä evästeitä sivusto ei toimi oikein. Nämä evästekäytännöt tallennetaan välttämättömiin evästeisiin.',
                        toggle: {
                            value: 'necessary',
                            enabled: true,
                            readonly: true          // cookie categories with readonly=true are all treated as "necessary cookies"
                        }
                    }, {
                        title: 'Suorituskyky- ja analysointievästeet',
                        description: 'Näiden evästeiden avulla näemme, miten eri sivumme toimivat ja miten käyttäjät liikkuvat sivustollamme.' +
                            'Kaikki tiedot näistä evästeitä kootaan yhteen ja anonymisoidaan. os et salli näitä evästeitä, emme tiedä, milloin olet käynyt sivuillamme emmekä voi seurata sivun toimivuutta.',
                        toggle: {
                            value: 'analytics',     // your cookie category
                            enabled: false,
                            readonly: false
                        },
                        cookie_table: [             // list of all expected cookies
                            {
                                col1: '^_ga',       // match all cookies starting with "_ga"
                                col2: 'google.com',
                                col3: '2 vuotta',
                                col4: 'Analytics -työkalu',
                                is_regex: true
                            },
                            {
                                col1: '_gid',
                                col2: 'google.com',
                                col3: '1 päivä',
                                col4: 'Analytics -työkalu',
                            }
                        ]
                    }, {
                        title: 'Muut',
                        description: 'Sivustolla on käytössä Facebookin ja Wodconnectin tarjoamia työkaluja, jotka saattavat asetaa itse evästeitä, joita me emme pysty hallitsemaan.',
                        toggle: {
                            value: 'other',
                            enabled: false,
                            readonly: false
                        }
                    }/*, {
								title: 'More information',
								description: 'For any queries in relation to our policy on cookies and your choices, please <a class="cc-link" href="#yourcontactpage">contact us</a>.',
							}*/
                ]
            }
        }
    }
};

export function roundToKg(w) {
    return 1.0 * Math.ceil(w / 1.0);
}
